import styled from 'vue-styled-components';

const btnProps = { primary: Boolean, fontColor: String };

export const StyledButton = styled('a', btnProps)`
  border: 2px solid red;
  border-radius: 3px;
  margin-top: 10px;
  padding: 10px;
  background: ${props => props.backgroundColor ? props.backgroundColor : 'none'};
  color: ${props => props.fontColor ? props.fontColor : 'none'};
`;

export default { StyledButton };